module.exports = __webpack_public_path__ + "menu2.jpg?56bc1a91498b817ac93b449577444439";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu2.jpg
// module id = 555
// module chunks = 0